import { Component, ViewChild, ElementRef } from '@angular/core';
import { ApiService } from '../../../service/api.service';
import { UtilsService } from 'src/app/service/helper/utils.service';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

export interface DialogData {
  text: string;
}

@Component({
  selector: 'call-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
  providers: [
    { provide: MAT_DATE_LOCALE, useValue: 'it-IT' },
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
  ],
})
export class CallDashboardComponent {
  @ViewChild('chartElementMI', { static: false }) chartElementMI: ElementRef<HTMLElement>;
  constructor(private utilsService: UtilsService, public ApiService: ApiService) { }
  startdate = new Date().setDate(new Date().getDate() - 7)
  enddate = new Date().getTime()
  availables = []
  plants = []
  groups = []
  totplants = []
  groupedplants = []
  total
  dailymean
  monthlymean
  currentavailable = "Tutti"
  currentgroup = "Tutti"
  currentplant = "Tutti"
  color = {
    white: '#fff',
    black: '#000',
    grey: '#7e8596',
    temperature: '#ED953A',
    humidity: '#7FB9F2',
    distance: '#FFF2AB',
    ec: '#C1FFBF',
    ph: '#fd5189',

  };
  getStart() {
    let d = new Date(new Date().setDate(new Date().getDate() - 7));
    var month = d.getMonth() + 1
    var date = d.getDate() + "/" + month + "/" + d.getFullYear()
    return date;
  }
  // startUpdated(start) {
  //   this.startdate = (new Date(start._selected._d)).getTime()
  //   this.createChart()
  // }
  // endUpdated(end) {
  //   this.enddate = (new Date(end._selected._d)).getTime()
  //   this.createChart()
  // }
  getEnd() {
    let d = new Date();
    var month = d.getMonth() + 1
    var date = d.getDate() + "/" + month + "/" + d.getFullYear()
    return date;
  }
  updateGroup(event) {
    this.currentgroup = event.target.value
    var newplants = []
    var tofilter = []
    var groupedplants = []
    if (this.currentgroup == "Tutti") {
      this.totplants.forEach(val=> {
        newplants.push(val.plantid + " - " + val.name)
      })
      this.plants = ["Tutti"].concat(newplants)
      this.currentplant = "Tutti"
    } else {
      var newplants = []
      var filtered = this.totplants.filter(function (el) {
        return el.groupid.includes(event.target.value.split(" - ")[0]);
      });
      filtered.forEach(val=> {
        newplants.push(val.plantid + " - " + val.name)
        tofilter.push(val.plantid.replaceAll("[","").replaceAll("]",""))
        groupedplants.push(val.plantid.replaceAll("[","").replaceAll("]",""))
      })
      this.plants = ["GRUPPO - " + event.target.value].concat(newplants)
      this.currentplant = "GRUPPO - " + event.target.value
    }
    var currentAvailable
    this.groupedplants = groupedplants
    if (this.currentavailable == "Tutti") {
      currentAvailable = []
    } else {
      currentAvailable = [this.currentavailable]
    }
    this.createChart(tofilter, currentAvailable)
  }
  updatePlant(event) {
    this.currentplant = event.target.value
    var currentAvailable
    if (this.currentavailable == "Tutti") {
      currentAvailable = []
    } else {
      var temp = this.currentavailable.split(" ")
      var availr = temp[1] + " " + temp[0]
      currentAvailable = [availr]
    }
    var avail
    if (event.target.value == "Tutti") {
      avail = []
    } else if (event.target.value.includes("GRUPPO")) {
      avail = this.groupedplants
    } else {
      avail = [event.target.value.split(" - ")[0]]
      
    }
    this.createChart(avail, currentAvailable)
  }
  updateAvailable(event) {
    this.currentavailable = event.target.value
    var currentplant
    if (this.currentplant == "Tutti") {
      currentplant = []
    } else if (this.currentplant.includes("GRUPPO")) {
      currentplant = this.groupedplants
    } else {
      currentplant = [this.currentplant.split(" - ")[0]]
    }
    var avail
    if (event.target.value != "Tutti") {
      var temp = event.target.value.split(" ")
      avail = [temp[1] + " " + temp[0]]
    } else {
      avail = []
    }

    this.createChart(currentplant, avail)
  }
  ngOnInit() {
    this.ApiService.getGroupsList().subscribe(v => {
      this.groups = ["Tutti"].concat(v.sort())
    })
    this.ApiService.getPlantsList().subscribe(v => {
      this.plants = ["Tutti"].concat(v.sort())
    })
    this.ApiService.getAvailablesList().subscribe(v => {
      var p = []
      v.forEach(l => {
        l = l.split(" ")
        p.push(l[1] + " " + l[0])
      })
      this.availables = ["Tutti"].concat(p)
    })
    this.ApiService.getPlantsTot().subscribe(v => {
      this.totplants = v.sort()
    })

    this.createChart([], [])
  }
  createChart(plants, availables) {
    var me = this
    this.ApiService.callstatusdashboard([], plants, availables).subscribe(result => {
      const chart = am4core.create(me.chartElementMI.nativeElement, am4charts.XYChart);
      chart.data = result.body;
      var total = result.body.reduce((accum,item) => accum + parseInt(item.value), 0)
      var dailymean = Math.floor(total/result.body.length) ? Math.floor(total/result.body.length) : 0
      var monthlymean = Math.floor(dailymean*30)

      this.total = total
      this.dailymean = dailymean
      this.monthlymean = monthlymean

      result.body.forEach(v => {
        v.timestamp = v.timestamp.split('T')[0]
      })
      chart.legend = new am4charts.Legend();
      chart.legend.labels.template.fill = am4core.color("white");
      chart.language.locale = am4lang_it_IT;
      chart.numberFormatter.language = new am4core.Language();
      chart.numberFormatter.language.locale = am4lang_it_IT;
      chart.dateFormatter.language = new am4core.Language();
      chart.dateFormatter.language.locale = am4lang_it_IT;
      chart.cursor = new am4charts.XYCursor();
      chart.cursor.behavior = "panX";
      chart.cursor.lineX.opacity = 0;
      chart.cursor.lineY.opacity = 0;
      chart.scrollbarX = new am4core.Scrollbar();
      chart.scrollbarX.parent = chart.bottomAxesContainer;
      chart.logo.disabled = true;
      chart.cursor = new am4charts.XYCursor();

      // Create axes
      let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "timestamp";
      categoryAxis.renderer.labels.template.rotation = 270;
      categoryAxis.renderer.labels.template.hideOversized = false;
      categoryAxis.renderer.minGridDistance = 20;
      categoryAxis.renderer.labels.template.horizontalCenter = "right";
      categoryAxis.renderer.labels.template.verticalCenter = "middle";
      categoryAxis.tooltip.label.rotation = 270;
      categoryAxis.tooltip.label.horizontalCenter = "right";
      categoryAxis.tooltip.label.verticalCenter = "middle";
      categoryAxis.renderer.labels.template.fill = am4core.color(this.color.white);
      var valueAxis = chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.title.text = "SMS/giorno";
      valueAxis.title.fill = am4core.color("white");
      valueAxis.renderer.labels.template.fill = am4core.color(this.color.white);

      // Create series
      let series = chart.series.push(new am4charts.LineSeries());
      series.dataFields.valueY = "value";
      series.dataFields.categoryX = "timestamp";
      series.tooltipText = "{name}\n{categoryX}: {valueY} SMS";
      series.name = "SMS";
      series.fill = am4core.color("blue");
      series.stroke = am4core.color("blue");
      series.zIndex = 100;
      series.fillOpacity = 0.7;
      series.tooltip.background.fill = series.fill;
    })
    this.utilsService.hideLoader();
  }
}

